import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CancelButton from './CancelButton';
import PrimaryButton from './PrimaryButton';
import { globalStyles as styles } from './style/gstheme';

class AreYouSure extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true
    };
  }

  notSure = () => {
    this.setState({ open: false });
    this.props.onNotSure();
  };

  sure = () => {
    this.setState({ open: false });
    this.props.onSure();
  };

  render() {

    const { message, classes } = this.props;

    return (
      <Dialog
        data-test="are-you-sure"
        open={this.state.open}
        onClose={this.notSure}
        aria-labelledby="areyousure-dialog-title" >
        <DialogTitle disableTypography className={classes.mainHeading} id="areyousure-dialog-title">Are You Sure?</DialogTitle>
        <DialogContent>
          {Array.isArray(message) ?
            message.map((line, index) => <DialogContentText key={index}>{line}</DialogContentText>
            )
            :
            <DialogContentText>{message}</DialogContentText>
          }
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <CancelButton onClick={this.sure}>Yes</CancelButton>
          <PrimaryButton onClick={this.notSure}>No</PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  }
}

AreYouSure.propTypes = {
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  onSure: PropTypes.func.isRequired,
  classes: PropTypes.object,
  onNotSure: PropTypes.func.isRequired
};

export default withStyles(styles)(AreYouSure);